<template>
  <div 
    :id="$attrs._id"
    class="tag-reference"
    :class="`tag-reference--tail-${tailPosition}` + ' ' + `is-hidden-${hideTagReference}`"
    :style="styles"
    ref="el"
    v-html="$attrs.tagLabel"
  >
  </div>
</template>
<script>
export default {
  props: [ 'pos', 'label', 'type', 'tail-position', 'hideTagReference'],

  computed: {
    styles () {
      return {
        // divide by font size
        left: `${(this.pos.x / 20) / 1.3}em`,
        top: `${(this.pos.y / 20) / 1.3}em`,
      }
    }
  },
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";


.tag-reference {
  align-items: center;
  background-color: $reference-tag-bg-color;
  border-radius: 50%;
  box-shadow: $tag-box-shadow;
  color: $reference-tag-font-color;
  cursor: grab;
  display: flex;
  font-family: $reference-tag-font-family;
  font-size: $reference-tag-font-size;
  font-weight: 400;
  height: $reference-tag-size;
  justify-content: center;
  line-height: normal;
  position: absolute;
  user-select: none;
  width: $reference-tag-size;
  z-index: 10;

  &.is-hidden-true {
    background: rgba(0, 0, 0, 0.75);
    border: .3em solid #e43c3c;

    &::after {
      content: none;
    }

    &::before {
      background: #e43c3c;
      content: '';
      height: 100%;
      position: absolute;
      transform: rotate(45deg);
      width: .3em;
      z-index: -1;
    }
  }

  &--tail-top-center:after {
    margin-bottom: calc(-0.4em / 1.3);
    @include tail(top, center, $reference-tag-bg-color, calc(1em / 1.3))
  }  

  &--tail-bottom-center:after {
    margin-top: calc(-0.4em / 1.3);
    @include tail(bottom, center, $reference-tag-bg-color, calc(1em / 1.3))
  }

  &--tail-left-center:after {
    margin-right: calc(-0.4em / 1.3);
    @include tail(left, center, $reference-tag-bg-color, calc(1em / 1.3))
  }  

  &--tail-right-center:after {
    margin-left: calc(-0.4em / 1.3);
    @include tail(right, center, $reference-tag-bg-color, calc(1em / 1.3))
  }    
}
</style>
